/* eslint-disable max-len */
import React, { Fragment } from 'react'
import { useSelector } from 'react-redux'
import TableBody from './TableBody'

export default function Table({ getFinancialYearRecodes, isRole }) {
    const FinancialYearList = useSelector(state => state.FinancialYearSlice)
    return (
        <div className='display' >
            <div className='-mx-1'>
                <div class="flex overflow-auto pb-[6px] scroll-bar px-1" id="search-result">
                    <table className='w-full' id="admin-table">
                        <thead>
                            <tr>
                                <th className="w-[20%]">
                                    <span className="flex items-center justify-start">Financial Year Name</span>
                                </th>
                                <th className="w-[12%]">
                                    <span className="flex items-center justify-start">Start Date</span>
                                </th>
                                <th className="w-[12%]">
                                    <span className="flex items-center justify-start">End Date</span>
                                </th>
                                <th className="w-[10%]">
                                    <span className="flex items-center justify-start">Status</span>
                                </th>
                                {!isRole && <th className="w-[15%]">
                                    <span className="flex items-center justify-center">Action</span>
                                </th>}
                            </tr>
                            <tr aria-colspan="7" className="h-1">
                            </tr>
                        </thead>
                        <tbody >
                            {FinancialYearList.List.financial_years.map((item) => (
                                <Fragment key={item._id}>
                                    <TableBody
                                        rowItem={item}
                                        isRole={isRole}
                                        getFinancialYearRecodes={getFinancialYearRecodes}
                                    />
                                </Fragment>
                            ))
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </div >
    )
}
